export function serializeCsv(data: string[][]): string {
  return data
    .map((row) =>
      row
        .map((field) => {
          const needsQuotes = field.includes(",") || field.includes('"') || field.includes("\n");
          const escapedField = field.replace(/"/g, '""');
          return needsQuotes ? `"${escapedField}"` : escapedField;
        })
        .join(",")
    )
    .join("\n");
}

/**
 * Downloads CSV data as a file without requiring a CSVLink component.
 */
export const downloadCsv = (data: string[][], filename: string) => {
  const csvContent = serializeCsv(data);

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
